import React from 'react';
import { Button, Input, Modal, ModalBody, ModalFooter } from 'reactstrap';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';

class ApplyCoupon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      couponName: '',
      openModal: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.applyCouponMessage.text !== '') {
      setTimeout(() => {
        nextProps.setApplyCouponMessage({ type: 'success', text: '' });
      }, 3000);
    }
  }

  applyCoupon = () => {
    this.props.applyCouponUser(this.state.couponName);
    this.setState({ couponName: '' });
  };

  renderModal(coupon, discount) {
    return (
      <Modal
        isOpen={this.state.openModal}
        toggle={() => this.setState({ openModal: !this.state.openModal })}
        className="modal-coupon-change-popup-content  modal-dialog-centered "
        modalClassName="modal-coupon"
      >
        <div className="modal-coupon-change-popup-header">
          <div className="title">
            Confirm coupon replacement
            <i
              className="icon-close"
              onClick={() =>
                this.setState({ openModal: !this.state.openModal })
              }
            />
          </div>
        </div>
        <div className="gradient-divider" />
        <ModalBody className="modal-body">
          <>
            <div className="title">
              You have currently applied the coupon{' '}
              <b className="bold">{`${coupon.name}`}</b> with a{' '}
              <b className="bold nowrap">{`${discount}`}</b>
            </div>
            <div className="warning-message">
              Applying a second coupon will replace the current one, and coupons
              are <br />
              single-use only
              <br />
            </div>
            <div className="description">Do you want to continue?</div>
          </>
        </ModalBody>
        <ModalFooter>
          <div className="switch-to-paid-confirmation modal-footer-buttons">
            <Button
              color="error"
              size="xs"
              block
              onClick={() =>
                this.setState({ openModal: !this.state.openModal })
              }
            >
              no, go back
            </Button>
            <Button
              className="btn-activate-subscription"
              size="xs"
              block
              onClick={() => {
                this.setState({ openModal: false });
                this.applyCoupon();
              }}
            >
              yes
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }

  render() {
    const { user, userSubscription, coupon, applyCouponMessage } = this.props;
    let discount = '';
    const message = '';
    if (coupon) {
      discount = coupon.amountOff
        ? `$${coupon.amountOff} off!`
        : `${coupon.percentageOff}% off!`;
    }
    return (
      <div className="apply-coupon-container">
        {!this.props.loadApplyCoupon ? (
          <div>
            {userSubscription &&
            (!userSubscription.isCancelled || userSubscription.isValidPlan) ? (
              <div>
                <div>
                  <div className="current-coupon">
                    <div className="current-applied-off">
                      <span className="title">Coupon applied:</span>
                      {coupon ? (
                        <span className="coupon">{coupon.name}</span>
                      ) : (
                        <i>No coupon applied</i>
                      )}
                    </div>
                    {coupon && (coupon.amountOff || coupon.percentageOff) && (
                      <div className="current-applied-off">
                        <span className="title">Coupon discount:</span>
                        <span className="discount">{discount}</span>
                      </div>
                    )}
                  </div>
                  {userSubscription.type === 'iOS' ? (
                    <div className="component-container">
                      We're sorry. Apple Subscriptions are not eligible for
                      discounts or other web-only benefits. Please cancel your
                      Apple Subscription first before signing up on the web.
                    </div>
                  ) : (
                    <>
                      <div className="component-container">
                        <div className="label">Coupon</div>
                        <Input
                          className="fade-in"
                          value={this.state.couponName}
                          type="text"
                          onChange={(e) =>
                            this.setState({
                              couponName: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="apply-coupon-bottom-buttons">
                        <div
                          className="bottom-button btn btn-outline-secondary btn-block rounded-lg"
                          onClick={() => {
                            if (this.state.couponName === '') return;
                            if (coupon) this.setState({ openModal: true });
                            else {
                              this.applyCoupon();
                            }
                          }}
                        >
                          APPLY COUPON
                        </div>
                        {this.renderModal(coupon, discount)}
                      </div>
                    </>
                  )}
                </div>

                {applyCouponMessage && applyCouponMessage.text !== 0 && (
                  <div className="message">
                    <span
                      className={
                        applyCouponMessage.type === 'success'
                          ? 'success'
                          : 'error'
                      }
                    >
                      {applyCouponMessage.text}
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <div className="cancelledSubscriptionMessage">
                You can apply your coupon by going to the page <br />
                <b>MANAGE MY SUBSCRIPTION</b>
                <br />
                to receive your discount.
              </div>
            )}
          </div>
        ) : (
          <div className="loading-container">
            <CircularLoading className="loading-gif-waiting" />
          </div>
        )}
      </div>
    );
  }
}

export default ApplyCoupon;
